// Package Imports
import { z } from 'zod'

// Core Imports
import { adminListSearchSchema } from '@/core/lib/table-search-schema'

const avatarValidationErrors = {
  name: {
    required: 'Avatar ismi alanı girilmesi zorunludur',
    min: 'Avatar ismi alanı en az 2 karakter olmalıdır',
    max: 'Avatar ismi alanı en fazla 50 karakter olmalıdır',
  },
  file: {
    required: 'Resim alanı girilmesi zorunludur',
  },
}

const { name, file } = avatarValidationErrors

export const avatarSearchSchema = adminListSearchSchema

export const createAvatarSchema = z.object({
  name: z.string().min(1, name.required).min(2, name.min).max(50, name.max),
  file: z.custom<File>().refine((file) => file instanceof File, {
    message: file.required,
  }),
})

export const editAvatarSchema = z.object({
  name: z
    .string()
    .min(1, name.required)
    .min(2, name.min)
    .max(50, name.max)
    .optional(),
  file: z.custom<File>().optional(),
})
